import { useQuery } from 'react-query';
import { UserInfo } from 'src/core/types/UserInfo';

import axios from './axios';

export function useUserInfo() {
  return useQuery<UserInfo>(
    'user-info',
    async () => {
      return axios
        .get<UserInfo>(`/posht/ashena/whoami/`)
        .then((res) => res.data);
    },
    { enabled: false },
  );
}
